import HeroSection from "../components/home/HeroSection";
import AboutPreview from "../components/home/AboutPreview";
import ProjectsPreview from "../components/home/ProjectsPreview";
import ContactPreview from "../components/home/ContactPreview";

export default function Home() {
  return (
    <div>
      <HeroSection />
      <hr className="border-white/10 max-w-6xl mx-auto" />
      <AboutPreview />
      <hr className="border-white/10 max-w-6xl mx-auto" />
      <ProjectsPreview />
      <hr className="border-white/10 max-w-6xl mx-auto" />
      <ContactPreview />
    </div>
  );
}
